import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { dentroTelegram } from '../../services/telegramAccesso';
import ApriNelBrowser from './ApriNelBrowser';

/**
 * /register: apre la finestra «Registrati» (FinestraRegistrazione, o il
 * pannello della skin Nova), non una pagina.
 *
 * Ci si arriva da un link diretto, dal vecchio pulsante e dal RITORNO DA
 * TELEGRAM (/register?code=…&state=…, l'indirizzo registrato in BotFather).
 * La query si mette da parte PRIMA di andare alla home, poi la si consegna a
 * chi apre la finestra: il modulo la legge e riprende da li' (Telegram
 * collegato, codice invito).
 *
 * La finestra sta nel guscio, che al primo caricamento monta DOPO di noi: si
 * aspetta un attimo, come fa AccessoDaLink. NIENTE clearTimeout all'uscita:
 * navigate('/') smonta subito questo componente e cancellerebbe la richiesta.
 */
export default function RegistrazioneDaLink({ userService }) {
  const navigate = useNavigate();
  // il pulsante del bot ha aperto il sito DENTRO Telegram: prima si propone il browser vero
  const [fuori] = useState(() => {
    const q = new URLSearchParams(window.location.search);
    return !!q.get('biglietto') && !q.get('qui') && dentroTelegram();
  });

  useEffect(() => {
    if (fuori) return;
    const ricerca = window.location.search || '';
    navigate('/', { replace: true });
    setTimeout(() => {
      if (userService && typeof userService.richiediRegistrazione === 'function') userService.richiediRegistrazione(ricerca);
    }, 80);
    // una volta sola, all'arrivo
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return fuori ? <ApriNelBrowser /> : null;
}
